export default "__VITE_ASSET__xF2Iz6Yw__"